import callApi from "../../api/axios";

export const getPartnerTracking = ({ pi, ue, st, et, limit, offset, type }) => {
  return callApi({
    method: "GET",
    url:
      type === "user"
        ? `trackings/users?ue=${ue}&limit=${limit}&offset=${offset}&type=user`
        : `trackings/users?pi=${pi}&st=${st}&et=${et}&limit=${limit}&offset=${offset}&type=partner`,
  });
};

export const createPartnerTracking = (values) => {
  return callApi({ method: "POST", url: `trackings/user`, data: values });
};

export const removePartnerTracking = (id) => {
  return callApi({
    method: "DELETE",
    url: `trackings/users/${id}`,
  });
};
